module.exports = __webpack_public_path__ + "img/selfAdhesive9.17f3801c.jpg";